import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import FormInputContainer from './containers/FormInputContainer';

let id = 0;

class Checkbox extends Component {
  constructor(...props) {
    super(...props);
    this.id = id++;
  }

  render() {
    const { input, label, meta, title, onChange, disabled } = this.props;
    const handleOnChange = input ? e => input.onChange(e.target.checked) : onChange;

    // TODO: This should not be required. Find all instances of title being passed as object and remove
    const description = typeof title === 'string' ? title.toLowerCase().split(' ').join('_') : this.id;

    return (
      <FormInputContainer meta={meta} type='checkbox' label={label} {...this.props}>
        <>
          <input
            {...input}
            type='checkbox'
            className='ncss-checkbox'
            id={`ncss-checkbox-${this.id}`}
            title={title}
            checked={input && input.value}
            onChange={handleOnChange}
            disabled={disabled}
            data-desc={`checkbox__${description}`}
            name={`ncss-checkbox-${this.id}`}
            value={input.checked || false}
          />
          <span className='checkbox-box circle' />
          <span className='checkbox-box' />
          <span className='checkbox-box-icon-container'>
            <svg aria-hidden='true' focusable='false' viewBox='0 0 24 24' role='img' height='24px' width='24px'>
              <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g transform='translate(2.000000, 2.000000)'>
                  <rect x='0' y='0' width='20' height='20' rx='10' />
                  <rect x='0' y='0' width='20' height='20' rx='5' className='checkicon-fill' />
                  <path
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M6.00134645 9.81868355 9.12119517 13.003429 14.9964286 7'
                    className='checkicon-check'
                  />
                </g>
              </g>
            </svg>
          </span>
          <label htmlFor={`ncss-checkbox-${this.id}`} title={title}>
            {label}
          </label>
        </>
      </FormInputContainer>
    );
  }
}

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.any.isRequired,
  title: PropTypes.string,
  input: PropTypes.any,
  meta: PropTypes.any,
  onChange: PropTypes.func
};

Checkbox.defaultProps = {
  disabled: false,
  title: '',
  input: null,
  meta: null,
  onChange: () => {}
};

export default Checkbox;
